import { Card, CardContent } from '@mui/material';

const CardWrapper = ({ children, sx = {}, contentSx = {} }) => {
  return (
    <Card sx={sx}>
      <CardContent sx={{ p: '40px', ...contentSx }}>{children}</CardContent>
    </Card>
  );
};

export default CardWrapper;
